<template>
	<div class="start">
		<v-cover
			:image="coverImage"
			:title="$t('startPage.titre')"
			:description="$t('startPage.bulyDescription')"
			:cta="$t('startPage.bulyCta')"
		/>
	</div>
</template>

<style lang="sass">
.start
  background-color: var(--light-grey)

</style>

<script>
import VCover from '@/components/VCover.vue'
import coverImage from '@/assets/images/portrait start.jpg'

export default {
	name: 'Start',

	created () {
		this.coverImage = coverImage
	},

	components: {
		VCover
	}
}
</script>
